/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_New_Share_CreatedInputs */



/**
* | output |
* | --- |
* | "New share created" |
*
* @param {Team_Share_New_Share_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_new_share_created = /** @type {((inputs?: Team_Share_New_Share_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_New_Share_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau partage créé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Aktie erstellt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuova condivisione creata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создана новая акция")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nueva acción creada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建了新份额")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しい共有が作成されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया शेयर बनाया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nova partilha criada")
	return /** @type {LocalizedString} */ ("New share created")
});